import { type EventRuleDto } from "@crowdcoursing/api/openapi";
import { useState } from "react";

interface UseEventJoinProps {
  rules: EventRuleDto[];
  onRequestJoin: () => void;
}

export const useEventJoin = ({ rules, onRequestJoin }: UseEventJoinProps) => {
  const [isRulesAgreementModalOpen, setIsRulesAgreementModalOpen] = useState(false);

  const handleJoinEvent = () => {
    if (rules?.length) {
      setIsRulesAgreementModalOpen(true);
    } else {
      onRequestJoin();
    }
  };

  const handleJoinWithRules = () => {
    setIsRulesAgreementModalOpen(false);
    onRequestJoin();
  };

  return {
    handleJoinEvent,
    handleJoinWithRules,
    isRulesAgreementModalOpen,
    onCloseRulesAgreementModal: () => setIsRulesAgreementModalOpen(false),
  };
};
